// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"23":"791d99e8","160":"80338577","208":"7769802e","293":"1c3ad692","516":"3433ba84","519":"9b42fdb6","917":"785e8d39","946":"0f6c8ffd"}[chunkId] + ".chunk.js";
};